<template>
  <div>
    <div class="image-container">
      <object v-if="isPdf" :data="src" type="application/pdf" class="pdf" aria-label="Plan du bloc (PDF)">
        <a :href="src" target="_blank" rel="noopener">Ouvrir le PDF</a>
      </object>
      <img
        v-else
        :src="src"
        class="image"
        :style="{ transform: 'scale(' + zoomLevel + ')' }"
        alt="Plan du bloc"
      />
    </div>
    <a v-if="isPdf" :href="src" target="_blank" rel="noopener" class="pdf-link">
      <v-icon small left>mdi-file-pdf-box</v-icon>Ouvrir le PDF dans un nouvel onglet
    </a>
  </div>
</template>

<script>
// Bloc plan of a bloc foré project: an image (zoomable by the parent) or a PDF
export default {
  name: "BlocPlan",
  props: {
    src: { type: String, required: true },
    isPdf: { type: Boolean, default: false },
    zoomLevel: { type: Number, default: 1 },
  },
};
</script>

<style scoped>
.image-container {
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.image {
  display: block;
  width: 100%;
  height: 100%;
  transition: transform 0.2s ease;
}
.pdf {
  display: block;
  width: 100%;
  height: 80vh;
}
.pdf-link {
  display: inline-block;
  margin-top: 8px;
}
</style>
